import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createBlock(_component_l_map, {
    ref: "map",
    zoom: $setup.zoom,
    center: $setup.center,
    "use-global-leaflet": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_l_tile_layer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" })
    ]),
    _: 1
  }, 8, ["zoom", "center"]))
}